<script setup lang="ts">
import { LOCALE } from "core/interfaces";

import { getKindLinks } from "~/common/helpers/get-kind-links";
import type { ShopComponentsResponseDto } from "~/common/interfaces/dto/shop/shop-components-response.dto";

const { isMobile } = useDevice();
const { locale } = useI18n();

const props = defineProps({
	components: {
		type: Object as PropType<ShopComponentsResponseDto>,
		default: () => {
			return {};
		}
	}
});

// const showOnlyInStock = ref(false);
const isFilterOpened = ref(false);
const links = computed(() => getKindLinks(locale.value as LOCALE, props.components.kinds, { hash: "#gallery" }));

const isFilterDisplayed = computed(() => !isMobile || isFilterOpened.value);

const toggleFilter = () => {
	isFilterOpened.value = !isFilterOpened.value;
};
</script>

<template>
	<aside>
		<ShopFilterButton
			v-show="isMobile"
			class="mb-6"
			@click="toggleFilter"
		/>
		<div
			v-show="isFilterDisplayed"
			class="flex flex-col gap-y-7 sm:mb-8 xs:mb-8"
		>
			<ShopFilterAccordion :title="$t('productCategories')">
				<ul>
					<li
						v-for="({name, link}, i) in links"
						:key="`${name}:${i}`"
					>
						<NuxtLink
							active-class="underline"
							class="underline-offset-8 hover:underline leading-[30px]"
							:to="link"
						>
							{{ name }}
						</NuxtLink>
					</li>
				</ul>
			</ShopFilterAccordion>
			<ShopFilterAccordion :title="$t('color', 2)">
				<ShopFilterColors :colors="components.colors" />
			</ShopFilterAccordion>
			<ShopFilterAccordion :title="`${$t('size', 2)} (cm)`">
				<ShopFilterSizes :sizes="components.sizes" />
			</ShopFilterAccordion>
			<ShopFilterAccordion :title="$t('collection', 2)">
				<ShopFilterCollections :collections="components.collections" />
			</ShopFilterAccordion>
			<ShopFilterAccordion :title="$t('tag', 2)">
				<ShopFilterTags :tags="components.tags" />
			</ShopFilterAccordion>
		<!-- <AppSwitch
			v-model="showOnlyInStock"
			title="Show only in-stock"
		/> -->
		</div>
	</aside>
</template>
